import React from 'react';
import { InnoAppHeader, InnoAppHeaderItem, InnoPopover } from '@innomotics/innomotics-build-react-lib';
import { Language } from '../../enums';
import { TRANSLATIONS } from '../../constants';
import { useAppDispatch, useTranslate, useAppSelector } from '../../hooks/common';
import { removeBanner, setLanguage } from '../../store';
import Banners from '../common/Banners';

type LanguageType = 'en' | 'de' | 'es' | 'fr' | 'it' | 'pt' | 'cn' | 'tr' | 'nl' | 'pl' | 'cs';

interface HeaderProps {
    title?: string;
}

const Header = ({ title }: HeaderProps) => {
    const banners = useAppSelector(state => state.banner.banners);
    const dispatch = useAppDispatch();
    const translate = useTranslate();
    const languages = Object.keys(Language).slice(0, Math.ceil(Object.keys(Language).length / 2)).map(x => Number(x));

    const handleLanguageChange = (language: Language) => {
        dispatch(setLanguage(language));
        window.localStorage.setItem('language', language.toString());
    };

    return (
        <header>
            <div className='main-row-container'>
                <InnoAppHeader className='header' app-name={title}>

                    <InnoAppHeaderItem
                        slot='header-custom-menu-content'
                        icon='envelope'
                        label='Support'
                        onClick={() => window.location.href = 'mailto:apps-support.it@innomotics.com'}>
                    </InnoAppHeaderItem>

                    <InnoAppHeaderItem
                        id='lang-trigger'
                        className='language-selector'
                        slot='header-custom-menu-content'
                        icon='globe'
                        label={translate(TRANSLATIONS.header.language)}>
                    </InnoAppHeaderItem>

                    <InnoPopover
                        for='#lang-trigger'
                        placement='bottom'>
                            {languages.map(x => (
                                <div className='languages' key={x} onClick={() => handleLanguageChange(x)}>
                                    <span>
                                        {translate(TRANSLATIONS.header.languages[Language[x].toLowerCase() as LanguageType])}
                                    </span>
                                </div>
                            ))}
                    </InnoPopover>

                </InnoAppHeader>
                <Banners banners={banners} removeBanner={x => dispatch(removeBanner(x))} />
            </div>
        </header>
    );
};

export default Header;
